import React from "react";
import { Dropdown, Space, Typography, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import type { CSSProperties, ReactNode } from "react";
import type { DropdownProps, MenuProps } from "antd";

import { W0 } from "@components/Constants";

const { Text } = Typography;

const TRIGGER_CLICK = "click";

const SPACE_SIZE = 4;

const BUTTON_STYLE: CSSProperties = {
  paddingLeft: W0,
  paddingRight: W0,
};

const NAME_STYLE: CSSProperties = { fontSize: 17 };

const ICON_STYLE: CSSProperties = {
  top: -1,
  fontSize: 11,
  position: "relative",
};

type Props = {
  name: ReactNode;
  items: MenuProps["items"];
  dropdownRender?: DropdownProps["dropdownRender"];
};

const DropdownButton = ({
  name,
  items,
  dropdownRender,
}: Props): JSX.Element => {
  const hasDropdownRender = !!dropdownRender;

  const extraProps: Pick<DropdownProps, "dropdownRender"> = hasDropdownRender
    ? { dropdownRender }
    : {};

  return (
    <Dropdown
      menu={{ items }}
      trigger={[ TRIGGER_CLICK ]}
      {...extraProps}
    >
      <Button
        type="text"
        style={BUTTON_STYLE}
      >
        <Space size={SPACE_SIZE}>
          <Text strong style={NAME_STYLE}>
            {name}
          </Text>

          <DownOutlined style={ICON_STYLE} />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default DropdownButton;
